import { useModel } from "bcms-react";
import { PageContainer, PageContentView } from "components/shared";

import "./styles.css";

export default function Navigation() {
    const options = useModel().branding.options;
    const ids = ["Nav_Accounts", "Nav_Zelle", "Nav_Transfers", "Nav_Payments", "Nav_Documents", "Nav_My_Finances", "Nav_Deposits"];

    // getPrev :: STRING -> STRING
    // Return the previous id in the ids array
    const getPrev = id => ids[ids.indexOf(id) - 1];
    // addClass :: STRING -> VOID
    // Add the 'active-item' class to the document item based on the passed id
    const addClass = id => document.querySelector(`[data-point="${ id }"] a`).classList.add("active-item");
    // handleOption :: STRING, STRING -> VOID
    // Based on the option value either add the class or call selectItem passing the previous id
    const handleOption = (option, id) => option === "true" ? addClass(id) : selectItem(getPrev(id));

    // selectItem :: STRING -> VOID
    // Check the passed id, if any of them have a specified case check that items branding option to see if
    // the class can be added or not
    const selectItem = dataPointID => {
        switch(dataPointID) {
            case "Nav_Zelle":
                handleOption(options.zle_abi22, dataPointID);
                break;

            case "Nav_Payments":
                handleOption(options.rxp17_abi22, dataPointID);
                break;

            case "Nav_My_Finances":
                handleOption(options.pfm21_abi22, dataPointID);
                break;

            case "Nav_Deposits":
                handleOption(options.deposits_abi22, dataPointID);
                break;
            
            case "Nav_Documents":
                handleOption(options.documents_abi22, dataPointID);
                break;

            default:
                addClass(dataPointID);
        }
    };

    // setActiveTab :: STRING -> VOID
    window.setActiveTab = dataPointID => selectItem(dataPointID);

    return (
        <PageContainer className="navigation-main-page">
            <PageContentView />
        </PageContainer>
    );
}